import request from "../clientsApi";
import { API_ROUTES } from "../../config/baseURL";

export const valoresNormalesApi = {
  getAll: async (consecutivo = "") => {
    const res = await request(API_ROUTES.getValoresNormales(consecutivo), {
      method: "GET",
    });
    return res.json();
  },

  getById: async (id) => {
    const res = await request(API_ROUTES.getValoresNormalesById(id), {
      method: "GET",
    });
    return res.json();
  },

  save: async (payload) => {
    const isUpdate = !!payload.id;
    const res = await request(API_ROUTES.saveValoresNormales, {
      method: isUpdate ? "PUT" : "POST",
      body: JSON.stringify(payload),
    });
    return res.json();
  },

  delete: async (id) => {
    const res = await request(API_ROUTES.deleteValoresNormales, {
      method: "POST",
      body: JSON.stringify({ id }),
    });
    return res.json();
  },
};

export default valoresNormalesApi;

